import React, { useEffect } from "react";
import { Form, Row } from "antd";
import { SearchBar } from "Components/General/SearchBar";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { ObjectAndDataRow, objectsAndDataStore } from "../Stores/ObjectsAndDataStore";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { ModuleHeader } from "Pages/Project/Components/ModuleHeader";
import { Loader } from "Components/General/Loader";
import { I18N_NS } from "Config/i18n";
import { Button } from "Components/General/Button";
import { withModal, WithModal } from "Components/General/Modal/withModal";
import { CreateNewObjectTypeModal } from "../Components/CreateNewObjectTypeModal";
import { projectsDataStore } from "Stores";
import { ScrollableTable, TableColumnProps } from "Components/ScrollableTable/ScrollableTable";
import { stringSort } from "utils/defaultSort";

interface ObjectsAndDataSearchResultProps extends WithModal {}

export const ObjectsAndDataSearchResult = withModal(
  observer(({ showModal }: ObjectsAndDataSearchResultProps) => {
    const { t } = useTranslation(I18N_NS.PROJECT);
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();

    useEffect(() => {
      (async () => {
        await objectsAndDataStore.init(navigate, location.pathname);
        await objectsAndDataStore.fetch(+params.id);
        await objectsAndDataStore.submitSearch(+params.id, location.search.slice(1));
      })();
      console.log(objectsAndDataStore?.searchResult);
    }, [location.search, params.id]);

    const handleSearch = async (value: string) => {
      try {
        await objectsAndDataStore.submitSearch(+params.id, value);
      } catch (error) {
        throw error;
      }
    };

    const handleRowClick = (params: { rowData: ObjectAndDataRow; index: number; event: React.MouseEvent }) => {
      event.preventDefault();
      navigate(
        `/project/${projectsDataStore.projectId}/values/${objectsAndDataStore.singleData.id}/sub-object/${params.rowData.key}`
      );
    };
    const dataSource = objectsAndDataStore.searchResult;

    const columns: TableColumnProps<never>[] = dataSource?.columns?.map((item) => {
      return {
        label: item,
        dataKey: item,
        width: 300,
        sorter: (a, b) => stringSort(a, b, item),
        cellRenderer: (data) => (
          <Link
            target="_blank"
            style={{ display: "block" }}
            to={`/project/${projectsDataStore.projectId}/values/${objectsAndDataStore.singleData.id}/sub-object/${data.rowData.key}`}
          >
            {data.rowData[data.dataKey]}
          </Link>
        ),
      };
    });
    /**columns.push({
      label: t("Actions"),
      width: 50,
      render: (_value, record) => {
        return (
          <ObjectsAndDataSearchResultItemActions 
            dataSource={dataSource} 
            instance={record} 
            editMode={objectsAndDataStore.singleData?.hasWriteAcl} 
          />
        );
      },
    }); */
    const createObjectModal = () => {
      showModal(CreateNewObjectTypeModal, {
        modalProps: {
          footer: null,
          width: 800,
          title: t("New {{name}}", { name: objectsAndDataStore.singleData?.nameSingleObject }),
          maskClosable: false,
        },
        componentProps: {
          createNewAttributes: objectsAndDataStore.createNewAttributes,
          tableId: objectsAndDataStore.singleData?.id,
          attributes: objectsAndDataStore.singleData?.attributes,
          fromSearch: true,
        },
      });
    };

    const searchAttributes = objectsAndDataStore.searchResult?.columns.join(", ");
    console.log(searchAttributes);
    return (
      <>
        <Row justify="space-between" style={{ flexWrap: "nowrap", flexDirection: "row", paddingBottom: 20 }}>
          <Form
            style={{ width: "100%", flexWrap: "nowrap", flexDirection: "row", display: "flex" }}
            onSubmitCapture={(e) => e.preventDefault()}
          >
            <SearchBar
              placeholder={t("Search in {{attributes}}", { attributes: searchAttributes })}
              onSearch={handleSearch}
              autoFocus={true}
              style={{ marginRight: 10, marginBottom: 0 }}
            />
            <Button
              disabled={!objectsAndDataStore.singleData?.hasWriteAcl}
              faIcon="plus"
              type="primary"
              onClick={createObjectModal}
            >
              {t("New {{name}}", { name: objectsAndDataStore.singleData?.nameSingleObject })}
            </Button>
          </Form>
        </Row>
        {objectsAndDataStore.state === "LOADING" || !dataSource?.searchResultColumns ? (
          <Loader />
        ) : (
          <>
            <div className="scrollable-table-wrapper collection-folder-table">
              <Row>
                <ModuleHeader
                  title={t("{{count}} {{name}} found", {
                    count: objectsAndDataStore.searchResult?.foundItemsCount,
                    name: objectsAndDataStore.searchResult?.objectName,
                  })}
                  style={{ flexGrow: 1, justifyContent: "center" }}
                />
              </Row>
              <ScrollableTable<never>
                rowKey={"key"}
                data={dataSource?.searchResultColumns as Array<never>}
                columns={columns}
                onRowClick={handleRowClick}
                resizeableHeaders={"OaD_" + objectsAndDataStore.singleData?.id}
              />
            </div>
          </>
        )}
      </>
    );
  })
);
